import { useCallback, useEffect, useRef, useState } from 'react'
import { proximoEstado, type EstadoSalvamento } from './rotuloSalvamento'

const MS_ATE_SUMIR = 3000

export function useSalvamento(): {
  estado: EstadoSalvamento
  executar: (acao: () => Promise<void>) => Promise<void>
  reiniciar: () => void
} {
  const [estado, setEstado] = useState<EstadoSalvamento>('ocioso')
  const timer = useRef<number | undefined>(undefined)

  // Limpa o timer ao desmontar: FormRepresentada, FormCliente e FormProduto
  // NAVEGAM apos criar um cadastro novo, entao o componente pode morrer antes
  // dos 3 segundos.
  useEffect(() => () => window.clearTimeout(timer.current), [])

  const executar = useCallback(async (acao: () => Promise<void>) => {
    window.clearTimeout(timer.current)
    setEstado((atual) => proximoEstado(atual, 'iniciou'))
    try {
      await acao()
      setEstado((atual) => proximoEstado(atual, 'concluiu'))
      timer.current = window.setTimeout(
        () => setEstado((atual) => proximoEstado(atual, 'expirou')),
        MS_ATE_SUMIR,
      )
    } catch {
      setEstado((atual) => proximoEstado(atual, 'falhou'))
    }
  }, [])

  // Chamado quando o usuario edita um campo: o que esta na tela deixou de ser
  // o que foi gravado, entao manter "Salvo" seria mentira.
  const reiniciar = useCallback(() => {
    window.clearTimeout(timer.current)
    setEstado('ocioso')
  }, [])

  return { estado, executar, reiniciar }
}
